import omit from "lodash/omit";
import {
  IConfiguration,
  TFeatureFlag,
  TFeatureFlagValues,
} from "models/configurations.models";

const getFeatureFlagValues = (
  featureFlagId: string,
  configurations: IConfiguration[],
): TFeatureFlagValues =>
  Object.fromEntries(
    configurations.map((config) => [
      config.tenantId,
      config.featureFlags.find(
        (featureFlag) => featureFlag.flag === featureFlagId,
      )?.enabled ?? false,
    ]),
  );

export const getFeatureFlags = (
  configurations: IConfiguration[],
): TFeatureFlag[] =>
  configurations.at(0)?.featureFlags.map((featureFlag) => ({
    ...omit(featureFlag, ["flag", "enabled"]),
    id: featureFlag.flag,
    name: featureFlag.flag,
    values: getFeatureFlagValues(featureFlag.flag, configurations),
  })) ?? [];
